import React from "react";

const MaximetroMetaBar = ({ meta, canRecalculate, onRecalculate }) => {
  if (!meta) return null;

  const reasonMap = {
    INITIAL: "Cálculo inicial",
    MANUAL_RECALC: "Recalculado manualmente",
  };

  return (
    <div className="maximeter-meta">
      <span>
        Versión {meta.version_number} ·{" "}
        Calculado el{" "}
        {new Date(meta.calculated_at).toLocaleString()} ·{" "}
        Motivo: {reasonMap[meta.calculation_reason] || meta.calculation_reason}
      </span>

      {canRecalculate && (
        <button
          className="btn-recalculate"
          onClick={onRecalculate}
          title="Genera una nueva versión del cálculo"
        >
          Recalcular
        </button>
      )}
    </div>
  );
};

export default MaximetroMetaBar;